import './App.css'
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';

import '@mantine/notifications/styles.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/home/HomePage.tsx";
import LoginPage from "./pages/login/LoginPage.tsx";
import DashboardPage from "./pages/dashboard/DashboardPage.tsx";
import Layout from './pages/layout/layout.tsx';
import { Notifications } from '@mantine/notifications';
import { useAuthState } from 'react-firebase-hooks/auth';
import { authFirebase } from './config.ts';
import PageNotFound from './pages/page-not-found/PageNotFound.tsx';
import { AppInformation } from './pages/home/components/AppInformation.tsx';

const theme = createTheme({
  colors: {
    clinic: [
      'rgb(251, 232, 211)',
      'rgb(251, 232, 211)',
      'rgb(246, 210, 188)',
      'rgb(232, 178, 165)',
      'rgb(219, 157, 150)',
      'rgb(146, 138, 151)',
      'rgb(146, 138, 151)',
      'rgb(40, 60, 99)',
      'rgb(40, 60, 99)',
      'rgb(40, 60, 99)',
    ],
    accent: [
      'rgb(255, 236, 239)',
      'rgb(254, 214, 220)',
      'rgb(252, 191, 201)',
      'rgb(251, 168, 182)',
      'rgb(249, 145, 163)',
      'rgb(248, 95, 115)',
      'rgb(225, 83, 102)',
      'rgb(201, 73, 91)',
      'rgb(177, 63, 80)',
      'rgb(153, 53, 69)',
    ],
  },
  primaryColor: 'clinic',
  primaryShade: 7,
  defaultRadius: 'md',
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
  },
});

function App() {
  const [user] = useAuthState(authFirebase);

  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="bottom-right" autoClose={4000} />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index path="/" element={<HomePage />} />
            <Route index path="/behavioral-health" element={<HomePage isGeneralClinic={false} />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/app-information" element={<AppInformation withHeader={true} />} />
            {(user || localStorage.getItem('accessToken')) && <Route path="/dashboard" element={<DashboardPage />} />}
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  )
}

export default App
